import * as React from 'react';
import { styled } from '@glitz/react';
import { Theme } from 'webapp/theme';
import { translate, useDynamicData } from '@avensia/excite';
import { UserIcon } from 'webapp/components/icons';
import { authenticateIfNeeded } from '@avensia/excite-commercetools/authentication';
import { useCustomerType } from '@avensia/excite-commercetools';
import { Button, ButtonLink } from 'webapp/components/button';
import { FieldSize } from 'webapp/components/field-size';
import { NnTestIdProps } from 'webapp/shared/test-ids';

export const MobileMenuBottomBar = () => {
  const { isCompanyCustomer, setCustomerType } = useCustomerType();
  const myPagesStartPageUrl = useDynamicData<NordicNest.Api.WellknownPagesApiModel>()[0]?.myPagesStartPageUrl;
  const isLoggedIn = useDynamicData<NordicNest.Api.CustomerApiModel>()[0]?.isLoggedIn;

  return (
    <BottomBar>
      <LoginButton
        disableRippleEffect
        size={FieldSize.Small}
        as={Theme.Monochrome}
        onClick={() => authenticateIfNeeded()}
        to={(isLoggedIn && myPagesStartPageUrl) || ''}
        {...NnTestIdProps.MobileMenuMyPagesButton}
      >
        <UserIconStyled css={isLoggedIn && LoginDecorator} />
        {isLoggedIn ? translate(t => t.header.myPages) : translate(t => t.login.loginAction)}
      </LoginButton>
      <Buttons>
        <CustomerCompanyButton
          css={isCompanyCustomer && selectedButtonDecorator}
          onClick={() => setCustomerType('company')}
          disableRippleEffect
          size={FieldSize.Small}
          as={Theme.Transparent}
        >
          {translate(t => t.customer.companyCustomer)}
        </CustomerCompanyButton>
        |
        <CustomerPrivateButton
          css={!isCompanyCustomer && selectedButtonDecorator}
          onClick={() => setCustomerType('private')}
          disableRippleEffect
          size={FieldSize.Small}
          as={Theme.Transparent}
        >
          {translate(t => t.customer.privateCustomer)}
        </CustomerPrivateButton>
      </Buttons>
    </BottomBar>
  );
};

const UserIconStyled = styled(UserIcon, {
  marginRight: t => t.spacing.xxs,
});

const LoginDecorator = styled({
  fill: t => t.dark.color,
});

const Buttons = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const LoginButton = styled(ButtonLink, {
  padding: { y: t => t.spacing.xs },
});

const selectedButtonDecorator = styled({
  fontWeight: 'bold',
});

const CustomerCompanyButton = styled(Button, {
  padding: { y: t => t.spacing.xs, right: t => t.spacing.xxs },
});

const CustomerPrivateButton = styled(Button, {
  padding: { y: t => t.spacing.xs, left: t => t.spacing.xxs },
});
const BottomBar = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: t => t.mobileMenu?.accentColor,
  width: '100%',
});
